import keyMirror from 'keymirror';

/**
 * Names for each state of the stage size toggle
 * @enum {string}
 */
const STAGE_SIZE_MODES = keyMirror({
    /**
     * The "large stage" button is pressed; the user would like a large stage.
     */
    large: null,

    /**
     * The "small stage" button is pressed; the user would like a small stage.
     */
    small: null
});

/**
 * Names for each stage render size
 * @enum {string}
 */
const STAGE_DISPLAY_SIZES = keyMirror({
    /**
     * Large stage with wide browser
     */
    large: null,

    /**
     * Large stage with narrow browser
     */
    largeConstrained: null,

    /**
     * Small stage (ignores browser width)
     */
    small: null
});

// zoom level to start with
const BLOCKS_DEFAULT_SCALE = 0.675;

// Dynamic block scales based on screen size
const BLOCKS_RESPONSIVE_SCALES = {
    mobile: 0.5,        // スマホ: より小さく
    tablet: 0.6,        // タブレット: 少し小さく
    desktop: 0.675,     // デスクトップ: デフォルト
    ultraWide: 0.7      // 極端な横長: 少し大きく
};

const STAGE_DISPLAY_SCALES = {};
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.large] = 0.9; // large mode, wide browser (reduced from 1.0)
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.largeConstrained] = 0.7; // large mode but narrow browser (reduced from 0.85)
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.small] = 0.45; // small mode, regardless of browser size (reduced from 0.5)

export default {
    standardStageWidth: 480,
    standardStageHeight: 360,
    fullSizeMinWidth: 0,
    tabletBreakpoint: 768,
    mobileBreakpoint: 480,
    fullSizePaintMinWidth: 1250
};

// Helper function to get responsive block scale
const getResponsiveBlockScale = () => {
    if (typeof window === 'undefined') return BLOCKS_DEFAULT_SCALE;
    
    const width = window.innerWidth;
    const height = window.innerHeight;
    const aspectRatio = width / height;
    
    let selectedScale;
    let screenType;
    
    // 極端な横長画面 (20:9以上)
    if (aspectRatio >= 20/9) {
        selectedScale = BLOCKS_RESPONSIVE_SCALES.ultraWide;
        screenType = 'ultraWide';
    }
    // モバイル画面
    else if (width <= 480) {
        selectedScale = BLOCKS_RESPONSIVE_SCALES.mobile;
        screenType = 'mobile';
    }
    // タブレット画面
    else if (width <= 768) {
        selectedScale = BLOCKS_RESPONSIVE_SCALES.tablet;
        screenType = 'tablet';
    }
    // デスクトップ画面
    else {
        selectedScale = BLOCKS_RESPONSIVE_SCALES.desktop;
        screenType = 'desktop';
    }
    
    return selectedScale;
};

export {
    BLOCKS_DEFAULT_SCALE,
    BLOCKS_RESPONSIVE_SCALES,
    getResponsiveBlockScale,
    STAGE_DISPLAY_SCALES,
    STAGE_DISPLAY_SIZES,
    STAGE_SIZE_MODES
};
